'use strict';

/**
 * @generated SignedSource<<078e33fc8ca018ba0645e4c6ebab290d>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cartId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "channel"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cartId",
            "variableName": "cartId"
        },
        {
            "kind": "Variable",
            "name": "channel",
            "variableName": "channel"
        }
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "offerId",
        "storageKey": null
    }, v3 = {
        "alias": null,
        "args": null,
        "concreteType": "Item",
        "kind": "LinkedField",
        "name": "shippableItems",
        "plural": true,
        "selections": [
            (v2 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "categories",
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v4 = {
        "alias": null,
        "args": null,
        "concreteType": "Bundle",
        "kind": "LinkedField",
        "name": "bundles",
        "plural": true,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bundleId",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "Item",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "itemId",
                        "storageKey": null
                    },
                    (v2 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "preOrderable",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deliveryMessage",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "DeliveryOptionsFieldQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "Cart",
                    "kind": "LinkedField",
                    "name": "cart",
                    "plural": false,
                    "selections": [
                        (v3 /*: any*/),
                        (v4 /*: any*/),
                        (v5 /*: any*/)
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "DeliveryOptionsFieldQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "Cart",
                    "kind": "LinkedField",
                    "name": "cart",
                    "plural": false,
                    "selections": [
                        (v3 /*: any*/),
                        (v4 /*: any*/),
                        (v5 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "5c1fbef28a97a8491bc567ec5706f41a",
            "id": null,
            "metadata": {},
            "name": "DeliveryOptionsFieldQuery",
            "operationKind": "query",
            "text": "query DeliveryOptionsFieldQuery(\n  $cartId: String!\n  $channel: CartChannel!\n) {\n  cart(cartId: $cartId, channel: $channel) {\n    shippableItems {\n      offerId\n      categories\n    }\n    bundles {\n      bundleId\n      items {\n        itemId\n        offerId\n        preOrderable\n      }\n    }\n    deliveryMessage\n    id\n  }\n}\n"
        }
    };
})();
node.hash = "9d9983361a79f87d5f1aa7ba9e9f5d28";

module.exports = node;
